import { createSelector } from 'reselect';

const selectHomepageState = () => (state) => state.get('homepage');

/* Individual Homepage */
const selectHomepage = () => createSelector(
	selectHomepageState(),
	(homepageState) => homepageState.get('homepage')
);

const selectHomepageLoading = () => createSelector(
	selectHomepageState(),
	(homepageState) => homepageState.get('homepageLoading')
);

const selectHomepageLoadingError = () => createSelector(
	selectHomepageState(),
	(homepageState) => homepageState.get('homepageLoadingError')
);

export {
	selectHomepage,
	selectHomepageLoading,
	selectHomepageLoadingError
};
